import React from "react";
import { CheckIcon, LockIcon, ShieldCheckIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
const includes = ["Les 6 volumes de la méthode complète", "Les 6 bonus exclusifs", "Fichiers PDF prêts à imprimer", "Accès immédiat et à vie", "Mises à jour gratuites"];
export function Pricing() {
  const time = useCountdown();
  return <section id="offre" className="px-5 py-20" data-id="element-77" data-mp="1vu1r8jpetdsw">
      <div className="mx-auto max-w-xl rounded-3xl border-2 border-gold bg-panel p-8 text-center sm:p-10" data-id="element-78" data-mp="1vutijibz4pdd">
        <p className="text-sm font-bold tracking-widest text-gold" data-id="element-79" data-mp="1ru184lrd8efi">OFFRE SPÉCIALE · -60 %</p>
        <h2 className="mt-3 font-display text-4xl uppercase text-cream" data-id="element-80" data-mp="25tsr70wqol0d">La méthode complète</h2>
        <div className="mt-6 flex items-end justify-center gap-4" data-id="element-81" data-mp="20sd12ufpfob4">
          <span className="pb-2 text-2xl text-mute line-through" data-id="element-82" data-mp="3h6v3vkvpwqf9">67 $</span>
          <span className="font-display text-7xl text-gold" data-id="element-83" data-mp="3c8a4fnoaiarv">27 $</span>
        </div>
        <p className="mt-1 text-sm text-mute" data-id="element-84" data-mp="3canypub5biyd">Paiement unique · aucun abonnement</p>
        <ul className="mx-auto mt-8 max-w-sm space-y-3 text-left" data-id="element-85" data-mp="3vz72o2kemxs4">
          {includes.map(item => <li key={item} className="flex gap-3 text-cream" data-id="element-86" data-mp="4v8n2tkd2pil">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden data-id="element-87" data-mp="9ta5dc9yqkt0" />
              {item}
            </li>)}
        </ul>
        <a href="#offre" className="mt-9 flex w-full items-center justify-center rounded-full bg-gold px-8 py-4 text-lg font-bold text-ink transition-transform duration-150 ease-out hover:-translate-y-0.5 active:scale-[0.98]" data-id="element-88" data-mp="eoz8tqp3slul">
          Oui, je veux le pack complet
        </a>
        <p className="mt-4 text-sm text-mute" data-id="element-89" data-mp="3rxv7zimobmd2">
          L'offre expire dans <span className="font-semibold tabular-nums text-gold" data-id="element-90" data-mp="3rz6brig4cu46">{time}</span>
        </p>
        <p className="mt-2 flex items-center justify-center gap-1.5 text-xs text-mute" data-id="element-91" data-mp="2uhy6fd29n60a">
          <LockIcon className="h-3.5 w-3.5" aria-hidden data-id="element-92" data-mp="2zg9g9nsk9gii" /> Paiement 100 % sécurisé
        </p>
      </div>

      <div className="mx-auto mt-12 flex max-w-2xl flex-col items-center gap-5 text-center sm:flex-row sm:text-left" data-id="element-93" data-mp="2rfjvbc0f4klk">
        <ShieldCheckIcon className="h-16 w-16 shrink-0 text-gold" aria-hidden data-id="element-94" data-mp="2mhi5874krl0l" />
        <div data-id="element-95" data-mp="315cz3qubjvf9">
          <h3 className="text-xl font-bold text-cream" data-id="element-96" data-mp="315wf320es9qn">Garantie satisfait ou remboursé de 7 jours</h3>
          <p className="mt-1 text-mute" data-id="element-97" data-mp="2w8d01zvvzsxn">
            Essayez la méthode sans risque. Si elle ne vous convient pas, envoyez-nous un e-mail et nous vous remboursons intégralement.
          </p>
        </div>
      </div>
    </section>;
}